<form [formGroup]="editForm" class="form__contact">
  <div class="form-group">
    <input class="form-control" type="text" placeholder="Họ tên ( * )" formControlName="name" />
  </div>
  <div class="form-group">
    <app-error-text [isDisplay]="isSaved && editForm.get('name')?.errors?.required" [message]="
        ('Họ tên' | translate) + (' bắt buộc nhập' | translate) | translate
      ">
    </app-error-text>
  </div>
  <div class="form-group">
    <div class="d-flex">
      <input-number class="w-100" [isSeparate]="false" [isInteger]="true" [placeholder]="'Số điện thoại  ( * )'"
        [amount]="editForm.value.phone" (result)="patchValue('phone', $event)">
      </input-number>
    </div>
  </div>
  <div class="form-group">
    <app-error-text [isDisplay]="isSaved && editForm.get('phone')?.errors?.required" [message]="
        ('Số điện thoại' | translate) + (' bắt buộc nhập' | translate)
          | translate
      ">
    </app-error-text>
    <app-error-text [isDisplay]="isSaved && editForm.value.phone && errors.lengthPhone"
      [message]="'Số điện thoại ít nhất 9 số' | translate">
    </app-error-text>
  </div>
  <div class="form-group">
    <input class="form-control" type="text" placeholder="Email" formControlName="email" />
  </div>
  <div class="form-group">
    <app-error-text [isDisplay]="isSaved && editForm.get('email')?.errors?.required" [message]="
        ('Email' | translate) + (' bắt buộc nhập' | translate) | translate
      ">
    </app-error-text>
    <app-error-text class="error-text" [message]="'Email không đúng định dạng' | translate" [isDisplay]="
        isSaved &&
        !editForm.get('email')?.errors?.required &&
        editForm.get('email')?.errors?.pattern
      ">
    </app-error-text>
  </div>
  <div class="form-group input__icon">
    <!-- <input type="date" class="form-control border-custom" placeholder="Ngày hẹn" formControlName="date" /> -->
    <div class="d-flex align-items-center justify-content-between" style="gap: 15px">
      <input-date [value]="editForm.value.date" (result)="patchValue('date', $event)" [isNoPast]="true">
      </input-date>
      <div class="d-flex">
        <input class="form-control mr-2" placeholder="giờ" formControlName="hour" type="number" />
        <input class="form-control" placeholder="phút" formControlName="minutes" type="number" />
      </div>
    </div>

    <em>Thời gian làm việc từ <strong>8:00 đến 17:00</strong> từ <strong>thứ 2 đến thứ 6</strong> hàng tuần</em>

    <!-- <div class="input-group bootstrap-timepicker">
            <input [ngxTimepicker]="picker11" class="form-control"
                formControlName="time" [format]="24">
            <ngx-material-timepicker #picker11>
            </ngx-material-timepicker>

            <span class="input-group-btn">
                <button type="button"  class="btn btn-default btn-calendar">
                    <img src="./assets/images/icon/ic-calendar.png" width="20" height="20">
                </button>
            </span>
        </div> -->
  </div>
  <div class="form-group">
    <app-error-text [isDisplay]="
        isSaved &&
        (editForm.get('date')?.errors?.required ||
          editForm.get('hour')?.errors?.required ||
          editForm.get('minutes')?.errors?.required)
      " [message]="
        ('Ngày hẹn, giờ, phút' | translate) + (' bắt buộc nhập' | translate)
          | translate
      ">
    </app-error-text>
    <app-error-text [isDisplay]="isSaved && errors?.date" [message]="
        ('Ngày hẹn' | translate) +
          (' phải là giờ hiện tại +30 phút.' | translate) | translate
      ">
    </app-error-text>
    <app-error-text [isDisplay]="isSaved && errors?.hour" [message]="
        ('Giờ hẹn' | translate) +
          (' phải là 0 - 23.' | translate) | translate
      ">
    </app-error-text>
    <app-error-text [isDisplay]="isSaved && errors?.minutes" [message]="
      ('Phút hẹn' | translate) +
        (' phải là 0 - 59.' | translate) | translate
    ">
    </app-error-text>
  </div>
  <div class="form-group">
    <textarea class="form-control" rows="8" placeholder="Nội dung cần tư vấn" formControlName="content"></textarea>
  </div>
  <div class="form-group">
    <app-error-text [isDisplay]="isSaved && editForm.get('content')?.errors?.required" [message]="
        ('Nội dung' | translate) + (' bắt buộc nhập' | translate) | translate
      ">
    </app-error-text>
  </div>
  <button class="btn common__btn" (click)="save()">Đặt lịch</button>
</form>